import { Button } from "@/components/primitives/button";
import { Pencil, CircleX } from "lucide-react";
import { useRtfInputState } from "@/zustand/RtfInputState";
import { useTranslation } from "react-i18next";
import MarkdownRenderer from "./messages/MarkdownRenderer";
import { useNavigationState } from "@/zustand/NavigationState";

export default function EditMessagePreview() {
  const { t } = useTranslation();
  const activeChatId = useNavigationState((state) => state.activeChatId);

  const editMessage = useRtfInputState(
    (state) => state.editMessages[activeChatId || ""],
  );
  const clearEditMessage = useRtfInputState((state) => state.clearEditMessage);

  if (!editMessage) {
    return null;
  }

  return (
    <div className="w-full">
      <div className="flex select-none items-center gap-2 rounded-md bg-muted px-3 py-1">
        <Pencil className="size-5 opacity-50" />
        <div className="flex w-full flex-col px-3 leading-5">
          <div className="text-sm text-secondary">{t("editMessage")}</div>
          <MarkdownRenderer
            className="line-clamp-1 opacity-50"
            content={editMessage.content.text}
          />
        </div>

        <Button
          size="icon"
          variant="ghost"
          onClick={() => clearEditMessage(editMessage.chatId)}
          className="!hover:bg-transparent size-5 shrink-0 !bg-transparent lg:cursor-pointer"
        >
          <CircleX />
        </Button>
      </div>
    </div>
  );
}
